(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/game-guide-tipsen/assets/javascripts/game-guide-tipsen.js') >= 0) return;  svs.modules.push('/components/tipsen/game-guide-tipsen/assets/javascripts/game-guide-tipsen.js');
"use strict";


const _svs$components$tipse = svs.components.tipsen.gameGuideTipsen,
  TipsenPlay = _svs$components$tipse.TipsenPlay,
  TipsenMenu = _svs$components$tipse.TipsenMenu,
  TipsenSystem = _svs$components$tipse.TipsenSystem,
  TipsenAbout = _svs$components$tipse.TipsenAbout,
  TipsenLottery = _svs$components$tipse.TipsenLottery,
  constants = _svs$components$tipse.constants;
const useQueryParam = svs.components.lbUtils.useQueryParam;
const menuItemsQs = constants.menuItemsQs,
  queryParam = constants.queryParam;
const GameGuideTipsen = () => {
  var _useQueryParam, _svs, _svs2, _svs3;
  const setItem = (_useQueryParam = useQueryParam(queryParam)) !== null && _useQueryParam !== void 0 ? _useQueryParam : menuItemsQs.play;
  const articleId = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.tipsen) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.spelguideConfig) === null || _svs === void 0 || (_svs = _svs.spelguide) === null || _svs === void 0 ? void 0 : _svs.article;
  const articleIdSystem = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.tipsen) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.spelguideConfig) === null || _svs2 === void 0 || (_svs2 = _svs2.spelguide) === null || _svs2 === void 0 ? void 0 : _svs2.articleSystem;
  const articleIdLottery = (_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.tipsen) === null || _svs3 === void 0 || (_svs3 = _svs3.data) === null || _svs3 === void 0 || (_svs3 = _svs3.spelguideConfig) === null || _svs3 === void 0 || (_svs3 = _svs3.spelguide) === null || _svs3 === void 0 ? void 0 : _svs3.articleLottery;
  return React.createElement(React.Fragment, null, React.createElement(TipsenMenu, {
    hasArticleIdLottery: Boolean(articleIdLottery),
    hasArticleIdSystem: Boolean(articleIdSystem)
  }), React.createElement("div", {
    className: "pg_tipsen_game_guide"
  }, setItem === menuItemsQs.play && React.createElement(TipsenPlay, null), setItem === menuItemsQs.about && React.createElement(TipsenAbout, {
    articleId: articleId
  }), setItem === menuItemsQs.system && React.createElement(TipsenSystem, {
    articleId: articleIdSystem
  }), setItem === menuItemsQs.lottery && React.createElement(TipsenLottery, {
    articleId: articleIdLottery
  })));
};
setGlobal('svs.components.tipsen.gameGuideTipsen.GameGuideTipsen', GameGuideTipsen);

 })(window);